// extracted by mini-css-extract-plugin
export default {"content":"zT5QwNse5W0QM0la24RK"};